"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const utils_1 = require("../utils");
const types = require("./types");
const errorMessage = utils_1.createErrorMessageReducer('config');
const isProcessing = utils_1.createIsProcessingReducer('config');
const config = utils_1.createReducer(null)({
    [types.FETCH_SUCCESS]: (state, action) => action.config,
});
// tslint:disable-next-line: no-default-export
exports.default = redux_1.combineReducers({
    errorMessage, isProcessing, config,
});
//# sourceMappingURL=reducers.js.map